export type AppTheme = 'base' | 'dark';

export type OptionItem = {
  value: string;
  label: string;
};

export type Options = OptionItem[];

export enum THEME {
  BASE = 'base',
  DARK = 'dark'
}

export enum LANGUAGE {
  EN = 'en',
  CN = 'cn'
}

// sysadmin module path need to start with /sysadmin
export enum APP_URL {
  ROOT_URL = '/',
  AUTH = '/auth',
  MAIL_BOXES = '/mailboxes',
  TEAMS = '/teams',
  USERS = '/users',
  LOGOUT = '/logout',
  REPORTING = '/reporting',
  REPORTING_OLD = '/reporting-old',
  NEW_ENQUIRY = '/enquiries/new',
  ANONYMOUS_VIEW = '/enquiries/:enquiryId',
  UPGRADE = '/upgrade',
  ONBOARDING = '/onboarding',
  SETTINGS = '/settings',
  WELCOME = '/welcome',
  EULA = '/eula',
  SYSADMIN_ORG = '/sysadmin/organisations',
  SYSADMIN_FREE_PLAN = '/sysadmin/free/plan/users',
  MAINTENANCE = '/maintenance'
}

export enum OTHER_URL {
  HELP = 'http://help.smarterwx.com.au/swxlocate/'
}

export enum SCREEN_SIZE {
  SM = 'SM',
  MD = 'MD',
  LG = 'LG',
  XL = 'XL',
  MAX = 'MAX'
}

export enum SCREEN_BREAK_POINT {
  SM = 320,
  MD = 672,
  LG = 1056,
  XL = 1312,
  MAX = 1584
}

export interface AddressType {
  line1: string | null;
  line2: string | null;
  country: string | null;
  locality: string | null;
  postcode: string | null;
  state: string | null;
}

export enum USERSROLE {
  SYSADMIN = 'SysAdmin',
  ORGADMIN = 'Organisation Admin',
  MANAGER = 'Manager',
  USER = 'User',
  TRIALUSER = 'Trial User'
}
